import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  Roles,
  StatusService,
  ChildPermissions,
  ParentPermissions,
} from "app/modules/core/services/user/status.service";
import { AuthService } from "app/modules/core/services/auth/auth.service";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  submenu?: RouteInfo[];
  isSubMenuOpen?: boolean;
  permission?: string;
  permissions?: string[]; // show if user has ANY of these
}

export const ROUTES: RouteInfo[] = [
  {
    path: "dashboard",
    title: "Dashboard",
    icon: "dashboard",
    class: "",
    permission: "Test",
  },
  {
    path: "user",
    title: "User Management",
    icon: "group",
    class: "",
    permission: "UsersRolesManage",
    submenu: [
      {
        path: "user/user-management",
        title: "User Management",
        icon: "list",
        class: "",
        permission: "UsersManagement",
      },
      {
        path: "user/role-management",
        title: "Role Management",
        icon: "person_add",
        class: "",
        permission: "RoleManagement",
      },
    ],
  },
  {
    path: "standards-and-codes",
    title: "Standards and Codes",
    icon: "library_books",
    class: "",
    permission: "Library",
    submenu: [
      {
        path: "standards-and-codes/manage",
        title: "Manage Library",
        icon: "library_books",
        class: "",
        permission: "ManageLibrary",
      },
      {
        path: "standards-and-codes/browser",
        title: "Browse",
        icon: "library_books",
        class: "",
        permission: "BrowseLibrary",
      },
    ],
  },
  {
    path: "report-templates",
    title: "Report Templates",
    icon: "library_books",
    class: "",
    permission: "ManageReportTemplates",
  },
  {
    path: "client-management",
    title: "Client Management",
    icon: "factory",
    class: "",
    permission: "ManageClients",
  },
  {
    path: "entity-management",
    title: "Entity Management",
    icon: "dataset",
    class: "",
    permission: "ManageEntities",
  },
  {
    path: "report-maintainer",
    title: "Report Maintenance",
    icon: "admin_panel_settings",
    class: "",
    permission: "ReportMaintainer",
    submenu: [
      {
        path: "report-maintainer/worksheets",
        title: "All Worksheets",
        icon: "table_view",
        class: "",
        permission: "AllWorkSheets",
      },
      {
        path: "report-maintainer/reports",
        title: "All Work Reports",
        icon: "fact_check",
        class: "",
        permission: "AllWorkReports",
      },
      {
        path: "report-maintainer/work-vouchers",
        title: "All Work Vouchers",
        icon: "receipt_long",
        class: "",
        permission: "AllWorkVouchers",
      },
    ],
  },
  {
    path: "my-reports",
    title: "My Reports",
    icon: "content_paste",
    class: "",
    permissions: ["Technician", "Supervisor", "Manager", "Accountant"],
    submenu: [
      {
        path: "my-reports/draft",
        title: "Draft",
        icon: "edit_note",
        class: "",
        permission: "DraftReports",
      },
      {
        path: "my-reports/submitted",
        title: "Submitted",
        icon: "assignment_turned_in",
        class: "",
        permission: "SubmittedReports",
      },
      {
        path: "my-reports/review",
        title: "Review",
        icon: "reviews",
        class: "",
        permission: "ReviewReports",
      },
      {
        path: "my-reports/approve",
        title: "For Approval",
        icon: "check_box",
        class: "",
        permission: "ApproveReports",
      },
      {
        path: "my-reports/past",
        title: "Past",
        icon: "history",
        class: "",
        permission: "PastReports",
      },
      {
        path: "my-reports/completed",
        title: "Completed Reports",
        icon: "history",
        class: "",
        permission: "CompletedReports",
      },
      {
        path: "work-voucher",
        title: "Work Voucher",
        icon: "library_books",
        class: "",
        permission: "WorkVoucher",
      },
      {
        path: "work-sheets",
        title: "Work Sheets",
        icon: "library_books",
        class: "",
        permission: "CompletedWorkSheets",
      },
    ],
  },
];

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.css"],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  menuItems: RouteInfo[] = [];
  childPermissions: ChildPermissions = new ChildPermissions();
  parentPermissions: ParentPermissions = new ParentPermissions();
  sideBarUserRolespermissionCode: string[] = [];
  childPermission$: Observable<ChildPermissions>;
  parentPermission$: Observable<ParentPermissions>;
  logoutButtonDisable: boolean = false;

  constructor(
    private _statusService: StatusService,
    private _authService: AuthService
  ) { }

  toggleSidebar() {
    const body = document.getElementsByTagName("body")[0];

    if (window.matchMedia(`(min-width: 992px)`).matches) {
      body.classList.toggle("sidebar-mini");
      // Persist state if needed
      const isMini = body.classList.contains("sidebar-mini");
      localStorage.setItem('sidebar-mini', isMini.toString());
      return;
    }

    body.classList.toggle("nav-open");
  }

  isSidebarMini(): boolean {
    return document.body.classList.contains('sidebar-mini');
  }

  ngOnInit() {
    this._statusService.getPermissionCodesChild()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        if (response != null) {
          Object.keys(response).forEach((key) => {
            if (response[key] !== undefined && response[key]) {
              if (!this.sideBarUserRolespermissionCode.includes(key)) {
                this.sideBarUserRolespermissionCode.push(key);
              }
            }
          });
          console.debug(Object.keys(response));
          console.debug(this.sideBarUserRolespermissionCode);
        }
      });

    this._statusService.getPermissionCodesParent()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        if (response != null) {
          Object.keys(response).forEach((key) => {
            if (response[key] !== undefined && response[key]) {
              if (!this.sideBarUserRolespermissionCode.includes(key)) {
                this.sideBarUserRolespermissionCode.push(key);
              }
            }
          });
          console.debug(Object.keys(response));
          console.debug(this.sideBarUserRolespermissionCode);
        }
      });

    this.menuItems = ROUTES.map((menuItem) => ({
      ...menuItem,
      isSubMenuOpen: JSON.parse(sessionStorage.getItem("isSubMenuOpen")),
    }));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleMenuItem(menuItem: RouteInfo) {
    if (menuItem.submenu && menuItem.submenu.length > 0) {
      menuItem.isSubMenuOpen = !menuItem.isSubMenuOpen;
      sessionStorage.setItem(
        "isSubMenuOpen",
        JSON.stringify(menuItem.isSubMenuOpen)
      );
      this.closeOtherSubMenus(menuItem);
    }
  }

  closeOtherSubMenus(currentMenuItem: RouteInfo) {
    this.menuItems.forEach((menuItem) => {
      if (
        menuItem !== currentMenuItem &&
        menuItem.submenu &&
        menuItem.submenu.length > 0
      ) {
        menuItem.isSubMenuOpen = false;
      }
    });
  }

  hasPermission(item: RouteInfo): boolean {
    if (item.permissions?.length) {
      return item.permissions.some(p => this.sideBarUserRolespermissionCode.includes(p));
    }
    return item.permission ? this.sideBarUserRolespermissionCode.includes(item.permission) : false;
  }

  isMenuItemActive(menuItem: RouteInfo): boolean {
    return false;
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  async logout() {
    if (this.logoutButtonDisable) {
      return;
    }

    this.logoutButtonDisable = true;
    try {
      // Clear permissions and menu state
      this.sideBarUserRolespermissionCode = [];
      this.menuItems = [];
      sessionStorage.removeItem("isSubMenuOpen");

      await this._authService.logoutUser();
    } finally {
      this.logoutButtonDisable = false;
    }
  }
}
